import React from 'react';
import PropTypes from 'prop-types';

import { RideGrid, RideBadge } from '@rimac-seguros/ride-system-components';

import FormHero from '../form-hero';

import './styles.scss';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { useAppContext } from '../../../AppProvider';

const RbrHeroSection = ({ authoring }) => {
  const {
    tag,
    title,
    description,
    heroMob,
    heroDesktop,
    heroCyberMob,
    heroCyberDesktop,
    titleCyber,
    descriptionCyber,
  } = authoring;

  const isLarge = useBreakpoint('large-min');
  const { state: { experiments: { experimentCyber } } } = useAppContext();

  const currentTitle = experimentCyber?.isActive ? titleCyber : title;
  const currentDescription = experimentCyber?.isActive ? descriptionCyber : description;
  const currentHeroMob = experimentCyber?.isActive ? heroCyberMob : heroMob;
  const currentHeroDesktop = experimentCyber?.isActive ? heroCyberDesktop : heroDesktop;

  return (
    <div id="section-hero">
      <RideGrid className="section-hero">
        <div className="section-hero_image">
          <div className="img-wrapper">
            {isLarge && (
              <img className="hero-desktop" src={currentHeroDesktop} alt="img-hero-desk" loading="lazy" />
            )}
            <img className="hero-mobile" src={currentHeroMob} alt="img-hero-mob" />
          </div>
        </div>
        <div className="section-hero_form">
          <div className="section-hero_form-title-container">
            <RideBadge case="attribute" type="subtle" primaryText={tag} className="w-fit" />
            <h2 className="title">
              {currentTitle}
            </h2>
            <p className="description-form">{currentDescription}</p>
          </div>
          <FormHero />
        </div>
        <div className="section-hero_line" />
      </RideGrid>
    </div>
  );
};

RbrHeroSection.propTypes = {
  authoring: PropTypes.shape({
    tag: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    heroMob: PropTypes.string.isRequired,
    heroDesktop: PropTypes.string.isRequired,
    heroCyberMob: PropTypes.string,
    heroCyberDesktop: PropTypes.string,
    titleCyber: PropTypes.string,
    descriptionCyber: PropTypes.string,
  }).isRequired,
};

export default RbrHeroSection;
